import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";
import { serviceConsumer } from "../../network/ServiceConsumer";
import Help from "../../Components/Help/Help";
import { postDownloadHandler } from "../../helper/printHandlers";
import EntryCard from "../../Components/EntryCard/EntryCard";
import { cardActions, entriesFrom, notEnteredIn, useCompetitionCounts } from "../../Components/EntryCard/entryCardModel";
import EventSite from "../EventSite/EventSite";
import { isEventToday, pageStateForEvent } from "../../helper/eventFeed";
import { setConversionRate } from "../Register-Events/helper";
import { useDispatch } from "react-redux";

const ViewFiesEdit = () => {

  const [loading, setloading] = useState(false);
  const [event, setEvent] = useState()
  const [collaborators, setCollaborators] = useState([])
  const [dancers, setDancers] = useState([])
  const [family, setFamily] = useState([])
  const [printing, setPrinting] = useState(false)
  const [printError, setPrintError] = useState("")

  const navigate = useNavigate();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search)
  const eventId = searchParams.get('id')
  const dispatch = useDispatch()

  const getAllDetails = async () => {
    try {
      const url = `${process.env.REACT_APP_BASE_URL}/feis/registered/dancers/${eventId}`
      const response = await serviceConsumer("GET", url)

     setConversionRate(dispatch,response?.eventData?.usdExchangeRate)
      setEvent(response?.eventData)
      setDancers(response?.result)

      const collaboratorsUrl = `${process.env.REACT_APP_BASE_URL}/feis/collaborators/${eventId}`
      const collaboratorsResponse = await serviceConsumer('GET', collaboratorsUrl)
      setCollaborators(collaboratorsResponse.result)
      // the family's dancers: "Enter another dancer" only when one isn't entered yet
      serviceConsumer("GET", `${process.env.REACT_APP_BASE_URL}/account/dancers`)
        .then((r) => setFamily(r?.dancers || []))
        .catch(() => {})
      setloading(false)
    }
    catch (error) {
      navigate("pageNotFound", { replace: true })
      setloading(false)
      //
    }
  }
  useEffect(() => {
    setloading(true)
    window.scrollTo(0, 0);
    getAllDetails()
  }, [])

  useEffect(() => {
    document.title = `Feis.link - ${event?.name}`
  }, [event])

  //button handlers
  const backToViewEvent = () => {
    navigate("/parent")
  };
  const urlEventName = event?.name?.split(" ").join("+")
  const competitorClickHandler = () => {
    navigate(`/competitors/${urlEventName}?id=${event?._id}`, {
      state: { from: "edit" },
    });
  };

  // the family's entry card, the same as on the dashboard (MC2 ecbc86f7)
  const pageState = pageStateForEvent(event && { ...event, eventType: "Feiseanna" });
  const today = isEventToday(event);
  const counts = useCompetitionCounts(event?._id, !!event);
  const printCard = (reg) =>
    postDownloadHandler(
      `${process.env.REACT_APP_BASE_URL}/registration/printcard/pdf`,
      { registrationId: reg._id, type: "one" },
      setPrinting,
      setPrintError,
      `${reg?.dancerData?.fname || "Number"}-NumberCard.pdf`
    );
  const entries = entriesFrom(dancers, {
    kind: "feis",
    event,
    onChange: (reg) => navigate(`/feis-edit-dancers/${event._id}?regId=${reg._id}`, { state: { event } }),
    onPrint: printCard,
  });
  const actions = cardActions({
    event,
    kind: "feis",
    notEntered: notEnteredIn(family, dancers),
    isTeacher: localStorage.getItem("isTeacher") === "true",
    go: {
      counts: competitorClickHandler,
      open: (url) => window.open(url, "_blank", "noopener,noreferrer"),
      add: () => navigate(`/register-dancers?id=${event._id}`, { state: { event } }),
      results: () => navigate(`/results/${urlEventName}?id=${event._id}`, { state: { event, from: "result" } }),
    },
  });

  return (
    <div>
      {loading && <Loader />}
      {!loading && event && (
        <EventSite
          event={event}
          kind="feis"
          state={today ? "today" : pageState}
          entered
          dancerCount={dancers?.length || 0}
          counts={counts}
          card={<EntryCard event={event} kind="feis" today={today} entries={entries} counts={counts} actions={actions} notice={printing ? "Making the number card…" : printError} />}
          collaborators={collaborators}
          onBack={backToViewEvent}
        />
      )}
      <Help />
    </div>
  );
};

export default ViewFiesEdit;
